import React from "react";
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PREFIX = 'Header';

const classes = {
  root: `${PREFIX}-root`,
  back: `${PREFIX}-back`,
  button: `${PREFIX}-button`,
  text: `${PREFIX}-text`
};

const Root = styled('div')((
  {
    theme
  }
) => ({

  [`& .${classes.back}`]: {
    padding: "0.2em",
    display: "flex",
    alignItems: "center",
    borderRadius: "5px",
    "&:hover": {
      cursor: "pointer",
      background: "#f5f5f5",
    },
  },

  [`& .${classes.button}`]: {
    margin: "0 0.2em",
    background: "#005287",
    color: "#fff",
    borderRadius: "50%",
  },

  [`& .${classes.text}`]: {
    textTransform: "uppercase",
    fontSize: "0.8rem",
    padding: "0.8em",
    borderRadius: "5px",
    color: "#005287",
  }
}));

const Header = () => {

  const history = useHistory();

  const redirect = () => {
    history.push("/library");
  };

  return (
    <Root className={classes.root}
	sx={{
		width: "100%",
	    display: "flex",
	    alignItems: "center",
	    margin: "0.5em 0",
	}}>
		<div>
	      <div className={classes.back} onClick={redirect}>
	        <ArrowBackIcon
	          className={classes.button}
	          aria-label="return to library search"
	        />
	        <span className={classes.text}>Back to search</span>
	      </div>
		</div>
    </Root>
  );
};

export default Header;
